import { Stack, Typography } from '@mui/material';

import { Tooltip } from '@/components/poppers/Tooltip/Tooltip';
import {
  SuggestableSuggestion,
  SuggestedValue,
} from '@/modules/aiSuggestions/AISuggestedValue/AISuggestedValue.types';
import { getSuggestedValue } from '@/modules/aiSuggestions/AISuggestedValue/AISuggestedValue.utils';
import { AcceptRejectSuggestionButtons } from '@/modules/aiSuggestions/components/AcceptRejectSuggestionButtons';
import { COLORS } from '@/styles/tokens/colors';

interface AISuggestedValueProps {
  suggestion: SuggestableSuggestion;
  onAcceptSuggestion: (id: string, value: SuggestedValue['value']) => void;
  onRejectSuggestion: (id: string) => void;
}

export function AISuggestedValue({
  suggestion,
  onAcceptSuggestion,
  onRejectSuggestion,
}: AISuggestedValueProps) {
  const { value, display } = getSuggestedValue(suggestion);

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      p={1}
      spacing={1}
      bgcolor={COLORS.FUNCTIONAL.SUCCESS[50]}
      sx={(theme) => ({
        borderBottomLeftRadius: theme.spacing(0.5),
        borderBottomRightRadius: theme.spacing(0.5),
      })}
      data-testid={`suggestion-${suggestion.kind}`}
    >
      <Typography
        variant="body-xs"
        textOverflow="ellipsis"
        whiteSpace="nowrap"
        overflow="hidden"
        color={COLORS.TEXT.PRIMARY}
        sx={{ cursor: 'default' }}
      >
        <Tooltip title={display} placement="top-start">
          <span>{display}</span>
        </Tooltip>
      </Typography>
      <AcceptRejectSuggestionButtons
        suggestionKind={suggestion.kind}
        onAcceptSuggestion={() => onAcceptSuggestion(suggestion.id, value)}
        onRejectSuggestion={() => onRejectSuggestion(suggestion.id)}
      />
    </Stack>
  );
}
